import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["displayText", "startDateHidden", "endDateHidden"]
  static values = {
    monthId: String,
    minDate: String,
    maxDate: String
  }

  connect() {
    // Store reference to this controller for the modal to access
    this.element.evaluationPeriodController = this
  }

  openModal() {
    const modal = document.getElementById('evaluation-period-modal')
    if (!modal) return

    // Get the modal controller
    const modalController = this.application.getControllerForElementAndIdentifier(
      modal,
      'evaluation-period-modal-dialog'
    )

    if (modalController) {
      modalController.open(this)
    }
  }
}
